import { useEffect } from 'react';
import { installSheetSwipe, SheetSwipeSpec } from './sheetSwipe';

/**
 * Mount once per app (root component): swipe-down-to-close for every bottom
 * sheet the specs describe. Pass a module-level (stable) array.
 */
const useSheetSwipe = (specs: SheetSwipeSpec[]) => {
  useEffect(() => installSheetSwipe(specs), [specs]);
};

export default useSheetSwipe;
